import React, { SetStateAction, useEffect, useState } from "react";
import {
    assetFamilyMaster,
    columnsInspectionCheckList,
    columnsTemplateCheckList,
    FaultAssetMapMaster,
    InspectionAssetMapMaster,
    InspectionTemplateMasterKey,
    TemplateMasterKey
} from "../../types/assetTypes";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../store/CommonSlice";
import {
    getFamilyAssetMasterDataList,
    getInspectionTemplateDataById,
    getInspectionTemplateDataList,
    getTemplateDataById,
    getTemplateDataList,
    saveInspectionTemplateMapping,
    saveServiceTemplate,
    saveServiceTemplateMapping
} from "../../api/Services/masterServie";
import { enqueueSnackbar } from "notistack";
import { CustomMessage } from "../../const/Spinner";
import { getUniqueAssetNamesByFamilyId } from "../../api/Services/assetServices";
import { Checkbox, FormControl, InputLabel, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Box, Grid, Card, SelectChangeEvent } from "@mui/material";
import { DropdownChangeEvent } from "primereact/dropdown";
import ReusablePrimeButton from "../../Component/Buttons/ReusablePrimeButton";
import { FILE_DOWNLOAD_PREVIEW, PAGESEND, PAGESTART } from "../../api/endpoint";
import ImagePreview from "../../Component/ImagePreview";
import { RootState } from "../../store/Reduxstore";

interface CreateInspectionAssetProps {
    setOpen: React.Dispatch<SetStateAction<boolean>>;
    selectedMapData: InspectionAssetMapMaster;
    setSelectedMapData: React.Dispatch<React.SetStateAction<InspectionAssetMapMaster>>;
}

const CreateInspectionAssetMapping: React.FC<CreateInspectionAssetProps> = ({ setOpen,
    selectedMapData, setSelectedMapData
}) => {

    const dispatch = useDispatch();
    const [inspectionAssetMapData, setFaultAssetMapData] = useState<InspectionAssetMapMaster>(selectedMapData
        //     {
        //     assetName: "",
        //     familyAssetId: 0,
        //     familyName: "",
        //     inspectionAssetMapId: 0,
        //     inspectionTemplateId: 0,
        //     inspectionTemplateName: ""
        // }
    );
    console.log("Data:", selectedMapData);
    useEffect(() => {
        if (selectedMapData.inspectionAssetMapId != 0) {
            console.log(">>");
            getTemplateList(selectedMapData.familyAssetId);
        }
    }, [selectedMapData])

    useEffect(() => {
        if (selectedMapData.assetName !== "") {
            console.log(">>");
            getAssetNameList(selectedMapData.familyAssetId);
        }
    }, [selectedMapData])

    useEffect(() => {
        if (selectedMapData.inspectionTemplateId != 0) {
            console.log(">>");
            getTemplateById(selectedMapData.inspectionTemplateId);
        }
    }, [selectedMapData])

    const [selectedData, setSelectedData] = useState<columnsInspectionCheckList[]>([]);
    const [familyTemplateData, setFamilyTemplateData] = useState<InspectionTemplateMasterKey[]>([]);
    const [familyAsset, setFamilyAsset] = useState<assetFamilyMaster[]>([]);
    const [assetName, setAssetNameList] = useState<{ value: string; label: string }[]>([]);
    const isEditMode = Boolean(inspectionAssetMapData?.inspectionAssetMapId);

    useEffect(() => {
        if (familyAsset.length === 0) getFamilyAssetList(1,PAGESEND);
    }, [familyAsset]);

    const getFamilyAssetList = async (page: number, rows: number) => {
        dispatch(setLoading(true));
        try {
            const { data, status } = await getFamilyAssetMasterDataList(page, rows, { familyAssetId: { value: "", matchMode: "startWith" } });
            if (status.code === 200 && data?.length > 0) {
                setFamilyAsset(data);
            } else {
                CustomMessage(status.message, "error", enqueueSnackbar);
            }
        } catch (error: any) {
            CustomMessage(error?.message, "error", enqueueSnackbar);
        } finally {
            dispatch(setLoading(false));
        }
    };

    const getTemplateList = async (familyAssetId: number) => {
        dispatch(setLoading(true));
        try {
            const response = await getInspectionTemplateDataList(familyAssetId);
            const { data, status } = response;
            if (status.code === 200 && data?.length > 0) {
                setFamilyTemplateData(data);
            } else {
                CustomMessage(status.message, "error", enqueueSnackbar);
            }
        } catch (error: any) {
            CustomMessage(error?.message, "error", enqueueSnackbar);
        } finally {
            dispatch(setLoading(false));
        }
    };

    const getTemplateById = async (inspectionTemplateId: number) => {
        dispatch(setLoading(true));
        try {
            const response = await getInspectionTemplateDataById(inspectionTemplateId);
            const { data, status } = response;
            if (status.code === 200 && data && data?.columns?.length > 0) {
                setSelectedData(data.columns);
            } else {
                CustomMessage(status.message, "error", enqueueSnackbar);
            }
        } catch (error: any) {
            CustomMessage(error?.message, "error", enqueueSnackbar);
        } finally {
            dispatch(setLoading(false));
        }
    };

    const getAssetNameList = async (familyAssetId: number) => {
        dispatch(setLoading(true));
        try {
            const { data, status } = await getUniqueAssetNamesByFamilyId(familyAssetId);
            if (status.code === 200 && Array.isArray(data) && data.length > 0) {
                const updatedData = data.map((assetName: string) => ({
                    value: assetName,
                    label: assetName,
                }));
                updatedData.unshift({ label: "--Select--", value: "" });
                setAssetNameList(updatedData);
            } else {
                CustomMessage(status.message, "error", enqueueSnackbar);
            }
        } catch (error: any) {
            CustomMessage(error?.message, "error", enqueueSnackbar);
        } finally {
            dispatch(setLoading(false));
        }
    };

    const handleSelectAssetNameChange = (e: SelectChangeEvent<any>) => {
        const selectedValues = e.target.value; // array of selected values (e.g., ['Pump', 'Valve'])
        const updatedData = { ...inspectionAssetMapData, assetName: selectedValues };
        setFaultAssetMapData(updatedData);
    };



    console.log(inspectionAssetMapData, 'inspectionAssetMapData');

    const handleClear = () => {
        setFaultAssetMapData({
            assetName: "",
            familyAssetId: 0,
            familyName: "",
            inspectionAssetMapId: 0,
            inspectionTemplateId: 0,
            inspectionTemplateName: ""
        });
        setSelectedData([]);
        setOpen(false);
    }

    console.log(setFaultAssetMapData, 'setFaultAssetMapData');
    const handleSave = async () => {
        if (!inspectionAssetMapData) return;
        if (!inspectionAssetMapData.familyAssetId || inspectionAssetMapData.familyAssetId === 0) {
            CustomMessage("Please select a Family Asset.", "error", enqueueSnackbar);
            return;
        }
        if (!inspectionAssetMapData.inspectionTemplateId || inspectionAssetMapData.inspectionTemplateId === 0) {
            CustomMessage("Please select a Service Template.", "error", enqueueSnackbar);
            return;
        }
        if (!inspectionAssetMapData.assetName || inspectionAssetMapData.assetName === "") {
            CustomMessage("Please select a Asset Name.", "error", enqueueSnackbar);
            return;
        }
        dispatch(setLoading(true));
        try {
            const response = await saveInspectionTemplateMapping(inspectionAssetMapData);
            const { data, status } = response;
            if (status.code === 200 || status.code === 201) {
                handleClear();
                CustomMessage(status.message, 'success', enqueueSnackbar);
            } else {
                CustomMessage(status.message, 'error', enqueueSnackbar);
            }
        } catch (error: any) {
            CustomMessage(error.message, 'error', enqueueSnackbar);
        } finally {
            dispatch(setLoading(false));
        }
    }

    const inspectionTypes = Array.from(
    new Set(
        selectedData.flatMap((col) =>
            col.inspectionTypeStatuses.map((status) => status.inspectionTypeName)
        )
    )
   );
   const userDetails = useSelector((state: RootState) => state.auth)
   



    return (
        <Box p={3}>

            <Card elevation={3} sx={{ p: 3, borderRadius: 2, background: "#f9f9f9" }}>
                <Grid container spacing={3}>
                    {/* Family Asset Dropdown */}
                    <Grid item xs={12} sm={6} md={4}>
                        <FormControl fullWidth>
                            <h6>Select Family</h6>
                            <Select
                                value={inspectionAssetMapData.familyAssetId}
                                className="bg-white"
                                onChange={(e) => {
                                    getTemplateList(e.target.value as number);
                                    getAssetNameList(e.target.value as number);
                                    setFaultAssetMapData({ ...inspectionAssetMapData, familyAssetId: e.target.value as number });
                                }}
                            >
                                {familyAsset.map((asset) => (
                                    <MenuItem key={asset.familyAssetId} value={asset.familyAssetId}>
                                        {asset.familyName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    {/* Template Dropdown */}
                    <Grid item xs={12} sm={6} md={4}>
                        <FormControl fullWidth>
                            <h6>Select Template</h6>
                            <Select
                                value={inspectionAssetMapData.inspectionTemplateId}
                                className="bg-white"
                                onChange={(e) => {
                                    getTemplateById(e.target.value as number);
                                    setFaultAssetMapData({ ...inspectionAssetMapData, inspectionTemplateId: e.target.value as number });
                                }}
                            >
                                {familyTemplateData.map((template) => (
                                    <MenuItem key={template.inspectionTemplateId} value={template.inspectionTemplateId}>
                                        {template.inspectionTemplateName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <h6>Select Asset Type</h6>
                        <FormControl fullWidth variant="outlined" style={{ background: "#fff", borderRadius: 5 }}>

                            <Select
                                multiple={!isEditMode}
                                className="bg-white"
                                value={inspectionAssetMapData.assetName || []}
                                onChange={handleSelectAssetNameChange}
                                displayEmpty
                                renderValue={(selected: any) => {
                                    if (!Array.isArray(selected)) {
                                        // single value for edit
                                        return selected || "Select Asset Types";
                                    }

                                    // multiple values for create
                                    return selected.length === 0
                                        ? "Select Asset Types"
                                        : selected.join(", ");
                                }}

                            >
                                <MenuItem disabled value="">
                                    Select Asset Types
                                </MenuItem>
                                {assetName.map((type) => (
                                    <MenuItem key={type.value} value={type.value}>
                                        {type.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            </Card>

            {/* Table */}
            {selectedData.length > 0 && (
                <TableContainer component={Paper} sx={{ mt: 3, boxShadow: 3, borderRadius: 2 }}>
                    <Table className="custom-table">
                        {/* <TableHead sx={{ background: "#e0e0e0" }}>
                            <TableRow>
                                <TableCell sx={{ fontWeight: "bold" }}>Column Name</TableCell>
                                {["Daily", "Monthly", "Weekly", "Yearly"].map((col) => (
                                    <TableCell key={col} sx={{ fontWeight: "bold" }}>{col}</TableCell>
                                ))}
                            </TableRow>
                        </TableHead> */}
                        {/* <TableBody>
                            {selectedData.map((col, i) => (
                                <TableRow key={i} sx={{ backgroundColor: i % 2 ? "#f5f5f5" : "#fff" }}>
                                    <TableCell sx={{ fontWeight: "bold" }}>{col.inspectionColumnName}</TableCell>
                                    {(["daily", "weekly", "monthly", "yearly"] as const).map((column, idx) => (
                                        <TableCell key={idx}>
                                            <Checkbox checked={col[column] || false} color="primary" disabled />
                                        </TableCell>
                                    ))}
                                </TableRow>
                            ))}
                        </TableBody> */}
                        <TableHead sx={{ background: "#e0e0e0" }}>
                            <TableRow>
                                <TableCell sx={{ fontWeight: "bold" }}>Column Name</TableCell>
                                {inspectionTypes.map((type) => (
                                    <TableCell key={type} sx={{ fontWeight: "bold" }}>
                                        {type}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {selectedData.map((col, i) => {
                                const attachment = col.attachments?.[0] || null;
                                const typeStatusMap = new Map(
                                    col.inspectionTypeStatuses.map((status) => [status.inspectionTypeName, status.isChecked])
                                );

                                return (
                                    <TableRow
                                        key={i}
                                        sx={{ backgroundColor: i % 2 ? "#f5f5f5" : "#fff" }}
                                    >
                                        <TableCell sx={{ fontWeight: "bold", width: "300px" }}>
                                            <div style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "12px",
                                            }}>
                                                <div
                                                    style={{
                                                        width: "59px",
                                                        height: "59px",
                                                        borderRadius: "50%",
                                                        border: "1px solid #ccc",
                                                        overflow: "hidden",
                                                        backgroundColor: "#f5f5f5",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        flexShrink: 0,
                                                    }}
                                                >
                                                    {attachment?.attachmentId && (
                                                        <ImagePreview
                                                            alt={`Attachment ${attachment.attachmentId}`}
                                                            src={`${FILE_DOWNLOAD_PREVIEW}${attachment.attachmentId}`}
                                                            style={{
                                                                width: "59px",
                                                                height: "59px",
                                                                borderRadius: "50%",
                                                                objectFit: "cover"
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                                <span>{col.inspectionColumnName}</span>
                                            </div>
                                        </TableCell>

                                        {inspectionTypes.map((type) => (
                                            <TableCell key={type}>
                                                <Checkbox
                                                    checked={!!typeStatusMap.get(type)}
                                                    color="primary"
                                                    disabled
                                                />
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                );
                            })}
                        </TableBody>

{/* 
                        <TableBody>
                            {selectedData.map((col, i) => {
                                const attachment =
                                    col.attachments && col.attachments.length > 0
                                        ? col.attachments[0]
                                        : null;

                                return (
                                    <TableRow
                                        key={i}
                                        sx={{ backgroundColor: i % 2 ? "#f5f5f5" : "#fff" }}
                                    >
                                        <TableCell sx={{ fontWeight: "bold", width: "300px" }}>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "12px",
                                                }}
                                            >
                                                
                                                <div
                                                    style={{
                                                        width: "59px",
                                                        height: "59px",
                                                        borderRadius: "50%",
                                                        border: "1px solid #ccc",
                                                        overflow: "hidden",
                                                        backgroundColor: "#f5f5f5",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        flexShrink: 0,
                                                    }}
                                                >
                                                    {attachment?.attachmentId ? (
                                                        <ImagePreview
                                                            alt={`Attachment ${attachment.attachmentId}`}
                                                            src={`${FILE_DOWNLOAD_PREVIEW}${attachment.attachmentId}`}
                                                            style={{
                                                                width: "59px",
                                                                height: "59px",
                                                                borderRadius: "50%",
                                                                objectFit: "cover"
                                                            }}
                                                        />
                                                    ) : null}
                                                </div>

                                                <span>{col.inspectionColumnName}</span>
                                            </div>
                                        </TableCell>

                                        {(["daily", "weekly", "monthly", "yearly"] as const).map((column, idx) => (
                                            <TableCell key={idx}>
                                                <Checkbox
                                                   checked={!!col?.[column as any]}

                                                    color="primary"
                                                    disabled
                                                />
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                );
                            })}
                        </TableBody> */}

                    </Table>
                </TableContainer>
            )}
            <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end", gap: 1 }}>
                <ReusablePrimeButton
                    label="Cancel"
                    onClick={handleClear}
                    className="p-button-secondary btn btn-secondary text-white h-45 w120"
                />
                {userDetails.role.some(
                r => r.roleName === "Admin" || r.roleName === "Inspection Mapping Write"
                ) && (
                <ReusablePrimeButton
                    label="Save"
                    onClick={handleSave}
                    className="btn btn-primary w120 h-45"
                />
                )}


            </Box>
        </Box>
    );

};


export default CreateInspectionAssetMapping;